export default __webpack_public_path__ + "static/media/waste-trash.2ec18ac1.jpg";